import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import API from '@/apiRequest';

export const useFranchisees = () => {
  const queryClient = useQueryClient();

  const useFranchiseesList = (options = {}) => useQuery({
    queryKey: ['franchisees'],
    queryFn: async () => {
      const { data } = await API.get('/franchisees');
      return data;
    },
    ...options,
  });

  const useAssignClientToFranchiseeMutation = (franchiseeId) => useMutation({
    mutationFn: async (assignmentData) => {
      const { data } = await API.post(`/franchisees/${franchiseeId}/clients`, assignmentData);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clients'] });
      queryClient.invalidateQueries({ queryKey: ['cards'] }); // Compatibility with existing Redux reload
    },
  });

  return {
    useFranchiseesList,
    useAssignClientToFranchiseeMutation,
  };
};
